import { DEFAULT_BORDER } from 'constants/global';

export const projectDescriptionCardStyle = {
  pos: 'relative',
  bottom: 'unset',
  right: 'unset',
  border: DEFAULT_BORDER,
  borderColor: 'line.gray',
  w: { mobile: '180px', laptop: '343px' },
  minH: { mobile: '181px', laptop: '263px' },
  m: '0px',
  mr: { mobile: '8px', tablet: '12px', laptop: '20px' },
  p: '0',
  tagProps: {
    pos: 'absolute',
    top: '8px',
    left: '8px',
    p: { mobile: '6.5px 12px', laptop: '15.5px 24px' },
  },
  cursor: 'pointer',
  _hover: { bgColor: 'bg.grayLight' },
};
